module.exports = __webpack_public_path__ + "img/logo-competti.ec67d61f.png";